export const INVALID_QUANTITY_MESSAGE =
  'Informe uma quantidade válida para habilitar esta opção.';
